/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Lines_No_Vehicle_TheseInputs */

const fr_map_lines_no_vehicle_these = /** @type {(inputs: Map_Lines_No_Vehicle_TheseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun véhicule ne circule sur ces lignes.`)
};

const en_map_lines_no_vehicle_these = /** @type {(inputs: Map_Lines_No_Vehicle_TheseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vehicle is running on these lines.`)
};

/**
* | output |
* | --- |
* | "No vehicle is running on these lines." |
*
* @param {Map_Lines_No_Vehicle_TheseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_lines_no_vehicle_these = /** @type {((inputs?: Map_Lines_No_Vehicle_TheseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Lines_No_Vehicle_TheseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_lines_no_vehicle_these(inputs)
	return en_map_lines_no_vehicle_these(inputs)
});